import { createFileRoute } from "@tanstack/react-router";
import { SysAIProviders } from "@client/components/settings/ai-models";

type ProviderTab = "defaults" | "added" | "available" | "def-management";

function isValidProviderTab(v: unknown): v is ProviderTab {
  return v === "defaults" || v === "added" || v === "available" || v === "def-management";
}

export const Route = createFileRoute("/_app/settings/ai-models")({
  validateSearch: (search: Record<string, unknown>) => ({
    providerTab: isValidProviderTab(search.providerTab) ? search.providerTab : "defaults",
  }),
  component: SysAIProviders,
});
